import React from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

type InputProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

export const UiTabPanel = ({ children, value, index }: InputProps) =>
  value === index ? (
    <div role="tabpanel">
      <Card style={{ margin: '1px' }}>
        <CardContent>{children}</CardContent>
      </Card>
    </div>
  ) : null;
